import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Welcome from "./pages/main/Welcome";
import BugbountyEntryPoint from "./pages/bugbounty/BugbountyEntrypoint";
import BugbountyCard from "./pages/bugbounty/BugbountyCard";
import {initGA, logPageView} from "./analitics";

function App() {


useEffect(() => {
	initGA();
}, []);


 // const [open, setOpen] = useState(false);
  const gridItems = [
    { label: "For Partners", to: "/partners", disabled: false },
    { label: "About Us", to: "/about", disabled: false },
    { label: "For Hackers", to: "/hackers", disabled: true }, // недоступный
    { label: "Blog", to: "/blog", disabled: false },
  ];

  return (

    <BrowserRouter>
<GAListener>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/bugbounty/" >
          <Route index element={<BugbountyEntryPoint />} />  {/* /bugbounty */}
          <Route path=":id" element={<BugbountyEntryPoint />} />   {/* /bugbounty/123 */}
        </Route>
      </Routes>
</GAListener>

    </BrowserRouter>
    
 
  );
};


const GAListener = ({children}) => {
	const location = useLocation();
	useEffect(() => {
		logPageView();
	}, [location]);
	return children;
};

export default App;
